<template>
	
	<v-app>	

		<!-- inicio (quienes somos) -->
		<About></About>
		

		<!-- formulario cotizar -->
		<Quote></Quote>


		<!-- porque nosotros -->
		<PorqueNosotros></PorqueNosotros>


		<!-- articulos blog -->
		<PostBlog></PostBlog>


		<!-- banner -->
		<Banner></Banner>


		<!-- contacto -->
		<Contact></Contact>

	</v-app>

</template>


<script>
  
  import About from './../components/About'
  import Quote from './../components/Quote'
  import PorqueNosotros from './../components/PorqueNosotros'
  import PostBlog from './../components/PostBlog'
  import Banner from './../components/Banner'
  import Contact from './../components/Contact'

  export default
  {
    components: {
      About,
      Quote,
      PorqueNosotros,
      PostBlog,
      Banner,
      Contact,
    }
  }

</script>